import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LinkIcon, PencilSquareIcon } from "@heroicons/react/24/outline";

const AnalyzeProperty = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(null); // 'idealista' | 'manual' | null
    const [error, setError] = useState(null);

    const createEmptyProperty = async () => {
        const response = await fetch(`${window.REACT_APP_API_ENDPOINT}/api/wizard/propiedades`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({})
        });
        if (!response.ok) throw new Error('Error al iniciar el análisis');
        return response.json();
    };

    const handleStart = async (modo) => {
        setLoading(modo);
        setError(null);
        try {
            const data = await createEmptyProperty();
            if (modo === 'idealista') {
                navigate(`/analizarpropiedad/${data.public_id}/importar`);
            } else {
                navigate(`/analizarpropiedad/${data.public_id}/paso1`);
            }
        } catch (err) {
            setError('Error al iniciar el análisis. Por favor, inténtalo de nuevo.');
        } finally {
            setLoading(null);
        }
    };

    return (
        <div className="max-w-2xl mx-auto px-4 py-8">
            <button
                onClick={() => navigate("/")}
                className="mb-4 text-blue-600 hover:underline text-sm"
            >
                ← Volver
            </button>

            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8">
                <div className="text-center mb-8">
                    <h1 className="text-2xl font-bold text-gray-900 mb-2">
                        Analizar una propiedad
                    </h1>
                    <p className="text-gray-500 text-sm">
                        ¿Cómo quieres empezar?
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {/* Opción Idealista */}
                    <button
                        onClick={() => handleStart('idealista')}
                        disabled={!!loading}
                        className="flex flex-col items-center text-center gap-3 p-6 border-2 border-blue-200 rounded-xl hover:border-blue-500 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 group"
                    >
                        <div className="w-12 h-12 bg-blue-100 group-hover:bg-blue-200 rounded-full flex items-center justify-center transition-colors">
                            <LinkIcon className="w-6 h-6 text-blue-600" />
                        </div>
                        <div>
                            <p className="font-semibold text-gray-900 mb-1">
                                {loading === 'idealista' ? 'Iniciando...' : 'Tengo anuncio en Idealista'}
                            </p>
                            <p className="text-xs text-gray-500">
                                Pega la URL y autocompletamos los datos y las fotos
                            </p>
                        </div>
                    </button>

                    {/* Opción manual */}
                    <button
                        onClick={() => handleStart('manual')}
                        disabled={!!loading}
                        className="flex flex-col items-center text-center gap-3 p-6 border-2 border-gray-200 rounded-xl hover:border-gray-400 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 group"
                    >
                        <div className="w-12 h-12 bg-gray-100 group-hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors">
                            <PencilSquareIcon className="w-6 h-6 text-gray-600" />
                        </div>
                        <div>
                            <p className="font-semibold text-gray-900 mb-1">
                                {loading === 'manual' ? 'Iniciando...' : 'Introducir datos manualmente'}
                            </p>
                            <p className="text-xs text-gray-500">
                                Rellena tú mismo la dirección y los datos del inmueble
                            </p>
                        </div>
                    </button>
                </div>

                {error && (
                    <div className="mt-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                        {error}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AnalyzeProperty;
